export default {
  set_all: (id: string) => `/v1/applications/${id}/changes/set_changes`,
  seen: (id: string) => `/v1/applications/${id}/changes/set_user_seen`
};
